
import {observable} from "mobx";
import {StoreBase, StoreDataType} from "shared/utilities/Store/StoreBase";
import { PDFControlBaseOptions} from "InternalShared/PageBuilder/Controls/Core/PDFControlBase.Options";
import {ControlTypeEnum} from "PageBuilder/pagebuilder/Controls/NormalPDFControlFactory";
import {FieldControlOptions} from "PageBuilder/pagebuilder/Controls/ControlsList/FieldControl.Options";




export class FieldSummaryItemOptions extends StoreBase{
    Id:string;
    Label:string;
    FieldSettings:FieldControlOptions;

    protected LoadDefaultValues() {
        this.Id='';
        this.Label='';
        this.FieldSettings=new FieldControlOptions().Merge();
    }
}

export class FieldSummaryOptions extends PDFControlBaseOptions{
    @observable
    Type:ControlTypeEnum;
    @StoreDataType(FieldSummaryItemOptions)
    Fields:FieldSummaryItemOptions[];


    protected LoadDefaultValues() {
        super.LoadDefaultValues();
        this.Fields=[];
        this.Type=ControlTypeEnum.Summary;
        this.Expandable=true;

    }
}
